module.exports = __webpack_public_path__ + "img/md-cellular.eb6f210e.svg";